import { render, staticRenderFns } from "./CommuneDashboardBadge.vue?vue&type=template&id=47f54844&scoped=true&"
import script from "./CommuneDashboardBadge.vue?vue&type=script&lang=js&"
export * from "./CommuneDashboardBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f54844",
  null
  
)

export default component.exports